<template>
  <div class="container-fluid">
    <div class="spinner-container" v-if="loading == 1">
      <div id="loader"></div>
    </div>
    <div class="row row-eq-height">
      <div class="col-lg-3 col-md-3 col-12 text-center border curr-data">
        <div class="devName pt-3">
          {{ this.devData.name ? this.devData.name : "" }}
        </div>
        <div class="devName py-3">
          {{ this.devData.devId ? this.devData.devId : "" }}
        </div>
        <div class="row m-2">
          <div
            class="col-lg-6 col-md-6 col-6 border curr-pol animate-bottom"
            v-if="this.devData.TVOC"
          >
            <div class="text-left">
              <small>TVOC</small>
            </div>
            <h2 class="p-2">{{ Math.round(this.devData.TVOC * 100) / 100 }}</h2>

            <div
              class="progress progress-striped mt-4 ml-2"
              style="height: 3px; width: 90%"
            >
              <div
                :class="
                  getTVOCRange(
                    Math.round(this.devData.TVOC * 100) / 100,
                    'color'
                  )
                "
                role="progressbar"
                aria-valuenow="10"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="{ width: this.TVOCbarwidth }"
              ></div>
            </div>
          </div>

          <div
            class="col-lg-6 col-md-6 col-6 border curr-pol animate-bottom"
            v-if="this.devData.HCHO"
          >
            <div class="text-left">
              <small>HCHO</small>
            </div>
            <h2 class="p-2">{{ (this.devData.HCHO / 1000).toFixed(2) }}</h2>
            <div
              class="progress progress-striped mt-4 ml-2"
              style="height: 3px; width: 90%"
            >
              <div
                :class="
                  getHCHORange((this.devData.HCHO / 1000).toFixed(2), 'color')
                "
                role="progressbar"
                aria-valuenow="10"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="{ width: this.HCHObarwidth }"
              ></div>
            </div>
          </div>

          <div class="col-lg-6 col-md-6 col-6 border curr-pol animate-bottom">
            <div class="text-left">
              <small>CO2</small>
            </div>
            <h2 class="p-2">{{ Math.round(this.devData.CO2 * 100) / 100 }}</h2>
            <div
              class="progress progress-striped mt-4 ml-2"
              style="height: 3px; width: 90%"
            >
              <div
                :class="
                  getCO2Range(Math.round(this.devData.CO2 * 100) / 100, 'color')
                "
                role="progressbar"
                aria-valuenow="10"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="{ width: this.CO2barwidth }"
              ></div>
            </div>
          </div>

          <div class="col-lg-6 col-md-6 col-6 border curr-pol animate-bottom">
            <div class="text-left">
              <small>PM1</small>
            </div>
            <h2 class="p-2">{{ this.devData.PM1 }}</h2>
            <div
              class="progress progress-striped mt-4 ml-2"
              style="height: 3px; width: 90%"
            >
              <div
                :class="getPM1Range(this.devData.PM1, 'color')"
                role="progressbar"
                aria-valuenow="10"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="{ width: this.PM1barwidth }"
              ></div>
            </div>
          </div>

          <div class="col-lg-6 col-md-6 col-6 border curr-pol animate-bottom">
            <div class="text-left">
              <small>PM2.5</small>
            </div>
            <h2 class="p-2">{{ this.devData.PM25 }}</h2>
            <div
              class="progress progress-striped mt-4 ml-2"
              style="height: 3px; width: 90%"
            >
              <div
                :class="getPM25Range(this.devData.PM25, 'color')"
                role="progressbar"
                aria-valuenow="10"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="{ width: this.PM25barwidth }"
              ></div>
            </div>
          </div>

          <div class="col-lg-6 col-md-6 col-6 border curr-pol animate-bottom">
            <div class="text-left">
              <small>PM10</small>
            </div>
            <h2 class="p-2">{{ this.devData.PM10 }}</h2>
            <div
              class="progress progress-striped mt-4 ml-2"
              style="height: 3px; width: 90%"
            >
              <div
                :class="getPM10Range(this.devData.PM10, 'color')"
                role="progressbar"
                aria-valuenow="10"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="{ width: this.PM10barwidth }"
              ></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p class="ubuntu-medium">
              Last Updated : {{ momentFun(devData.updatedAt) }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-lg-9 col-md-9 col-12 mt-3">
        <div class="row" style="height: 2rem">
          <router-link :to="routeTo" >
            <div class="back col-lg-1 col-sm-1" title="Back to all devices">
              <i class="fa fa-angle-double-left"></i>
            </div>
          </router-link>
          <div class="h5 col-sm-11 summary">Device Summary</div>
        </div>
        <div class="row py-3 ">
          <div class="col-sm-12 table-border">
            <div class="col-sm-12 pt-2 hdrs">
              <div class="row d-flex justify-content-around">
                <div class="col-sm-1">SO2</div>
                <div class="col-sm-1">NO2</div>
                <div class="col-sm-1">CO</div>
                <div class="col-sm-1">O3</div>
                <div class="col-sm-1">Temp</div>
                <div class="col-sm-1">Pres</div>
                <div class="col-sm-1">Humid</div>
              </div>
            </div>
            <div class="col-sm-12 rdngs">
              <div class="row d-flex justify-content-around">
                <div class="col-sm-1">{{ devData.SO2 || "-" }}</div>
                <div class="col-sm-1">{{ devData.NO2 || "-" }}</div>
                <div class="col-sm-1">{{ devData.CO || "-" }}</div>
                <div class="col-sm-1">{{ devData.O3 || "-" }}</div>
                <div class="col-sm-1">{{ devData.temperature }}</div>
                <div class="col-sm-1">{{ devData.pressure }}</div>
                <div class="col-sm-1">{{ devData.humidity }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 filter-div py-3">
            <span class="ubuntu-medium">Time Range</span>
            <button
              :class="[
                lastNReadings.num === 6 ? activeClass : '',
                'btn btn-sm',
              ]"
              @click="lastNReadings = { num: 6, type: 'hours' }"
            >
              6h
            </button>
            <button
              :class="[
                lastNReadings.num === 12 ? activeClass : '',
                'btn btn-sm',
              ]"
              @click="lastNReadings = { num: 12, type: 'hours' }"
            >
              12h
            </button>
            <button
              :class="[
                lastNReadings.num === 24 ? activeClass : '',
                'btn btn-sm',
              ]"
              @click="lastNReadings = { num: 24, type: 'hours' }"
            >
              24h
            </button>
            <button
              :class="[
                lastNReadings.num === 2 ? activeClass : '',
                'btn btn-sm',
              ]"
              @click="lastNReadings = { num: 2, type: 'days' }"
            >
              2d
            </button>
            <!-- <button
              :class="[
                lastNReadings.num === 7 ? activeClass : '',
                'btn btn-sm',
              ]"
              @click="lastNReadings = { num: 7, type: 'days' }"
            >
              1w
            </button>
            <button
              :class="[
                lastNReadings.num === 14 ? activeClass : '',
                'btn btn-sm',
              ]"
              @click="lastNReadings = { num: 14, type: 'days' }"
            >
              2w
            </button>
            <button
              :class="[
                lastNReadings.num === 1 && lastNReadings.type === 'months'
                  ? activeClass
                  : '',
                'btn btn-sm',
              ]"
              @click="lastNReadings = { num: 1, type: 'months' }"
            >
              1m
            </button> -->
          </div>
        </div>
        <div
          class="row graph border"
          v-if="modal == 1"
          style="height: 60vh"
        ></div>
        <div class="row chartCont" style="height: 60vh">
          <div class="col-sm-12">
            <div class="row d-flex justify-content-end">
              <div class="col-sm-3 py-4">
                <div class="form-group">
                  <select
                    class="form-control"
                    v-model="drpdwnParam"
                    @click="setChartData(drpdwnParam)"
                  ><option v-for="param in paramArray" v-bind:key="param">
                      {{ param === 'PM25' ? 'PM2.5' : param }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <graph
                  :y-axis="hist"
                  :name="drpdwnParam"
                  :title="drpdwnParam"
                  class="animate-bottom"
                ></graph>
              </div>
            </div>
          </div>
        </div>
        <div class="row graph d-none" v-if="modal == 0" style="height: 85vh">
          <!-- <div class="row graph"> -->
          <div class="col-lg-4 border text-left chart">
            <div
              class="button btn-sm text-right"
              data-toggle="modal"
              data-target="#myModal"
            >
              <span
                class="cursor-pointer"
                data-toggle="tooltip"
                title="Maximize"
                @click="maximize('TVOC')"
              >
                <i
                  class="fa fa-expand"
                  aria-hidden="true"
                  style="font-size: 10px"
                ></i>
              </span>
            </div>
            <graph
              :y-axis="histTvoc"
              name="TVOC"
              title="TVOC"
              class="animate-bottom"
            ></graph>
          </div>
          <div class="col-lg-4 border chart">
            <div
              class="button btn-sm text-right"
              data-toggle="modal"
              data-target="#myModal"
            >
              <span
                class="cursor-pointer"
                data-toggle="tooltip"
                title="Maximize"
                @click="maximize('HCHO')"
              >
                <i
                  class="fa fa-expand"
                  aria-hidden="true"
                  style="font-size: 10px"
                ></i>
              </span>
            </div>
            <graph
              :y-axis="histHcho"
              name="HCHO"
              title="HCHO"
              class="animate-bottom"
            ></graph>
          </div>
          <div class="col-lg-4 border chart">
            <div
              class="button btn-sm text-right"
              data-toggle="modal"
              data-target="#myModal"
            >
              <span
                class="cursor-pointer"
                data-toggle="tooltip"
                title="Maximize"
                @click="maximize('CO2')"
              >
                <i
                  class="fa fa-expand"
                  aria-hidden="true"
                  style="font-size: 10px"
                ></i>
              </span>
            </div>
            <graph
              :y-axis="histCo2"
              name="CO2"
              title="CO2"
              class="animate-bottom"
            ></graph>
          </div>
          <div class="col-lg-4 border chart">
            <div
              class="button btn-sm text-right"
              data-toggle="modal"
              data-target="#myModal"
            >
              <span
                class="cursor-pointer"
                data-toggle="tooltip"
                title="Maximize"
                @click="maximize('PM1')"
              >
                <i
                  class="fa fa-expand"
                  aria-hidden="true"
                  style="font-size: 10px"
                ></i>
              </span>
            </div>
            <graph
              :y-axis="histPm1"
              name="PM1"
              title="PM1"
              class="animate-bottom"
            ></graph>
          </div>
          <div class="col-lg-4 border chart">
            <div
              class="button btn-sm text-right"
              data-toggle="modal"
              data-target="#myModal"
            >
              <span
                class="cursor-pointer"
                data-toggle="tooltip"
                title="Maximize"
                @click="maximize('PM25')"
              >
                <i
                  class="fa fa-expand"
                  aria-hidden="true"
                  style="font-size: 10px"
                ></i>
              </span>
            </div>
            <graph
              :y-axis="histPm25"
              name="PM25"
              title="PM25"
              class="animate-bottom"
            ></graph>
          </div>
          <div class="col-lg-4 border chart">
            <div
              class="button btn-sm text-right"
              data-toggle="modal"
              data-target="#myModal"
            >
              <span
                class="cursor-pointer"
                data-toggle="tooltip"
                title="Maximize"
                @click="maximize('PM10')"
              >
                <i
                  class="fa fa-expand"
                  aria-hidden="true"
                  style="font-size: 10px"
                ></i>
              </span>
            </div>
            <graph
              :y-axis="histPm10"
              name="PM10"
              title="PM10"
              class="animate-bottom"
            ></graph>
          </div>
        </div>
      </div>
    </div>
    <Maximize
      :deviceId="this.$route.params.deviceId"
      :pol="this.expandPol"
    ></Maximize>
  </div>
</template>
<script>
import _ from "underscore";
import moment from "moment";
import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";
import { apiCall } from "@/utils/api";
import graph from "./Graph";
import Maximize from "./Maximize";

exportingInit(Highcharts);

export default {
  mounted() {
    this.getDeviceData();
    this.getDeviceReading();
  },
  components: {
    graph,
    Maximize,
  },
  data() {
    return {
      loading: 0,
      devData: [],
      devId: "",
      graphDevId: "",
      dataType: "",
      history: [],
      TVOCbarwidth: "",
      HCHObarwidth: "",
      PM10barwidth: "",
      CO2barwidth: "",
      PM1barwidth: "",
      PM25barwidth: "",
      category: "",
      histTvoc: [],
      histHcho: [],
      histCo2: [],
      histPm1: [],
      histPm10: [],
      histPm25: [],
      categories: [],
      autoRefresh: 0,
      expandPol: "",
      drpdwnParam: "PM2.5",
      lastNReadings: {
        num: 24,
        type: "hours",
      },
      activeClass: "active",
      modal: 0,
      paramArray: [],
      hist : [],
      routeTo : parseInt(JSON.parse(localStorage.getItem("user")).roleId) === 3 ? '/search' : '/devices'
    };
  },
  methods: {
    momentFun(date) {
      return moment(date).format("DD MMM YYYY, hh:mm A");
    },
    setChartData(para) {
      let param = para === 'PM2.5' ? 'PM25' : para;
      this.hist = this.history.map((element) =>
        [
              moment(element.createdAt).format('DD MMM YYYY,hh:mm A'),
              parseFloat(Math.round(element[param] * 100) / 100),
            ]
      );
    },
    getDeviceReading() {
      let deviceId = this.$route.params.deviceId;
      let to = moment.utc().unix();
      let from = moment
        .utc()
        .subtract(this.lastNReadings.num, this.lastNReadings.type)
        .unix();
      var url = `reading?devId=${deviceId}&from=${from}&to=${to}`;
      if (this.autoRefresh !== 1) {
        this.loading = 1;
      }
      apiCall({ url, method: "get" }).then((result) => {
        this.history = result.data;
        this.history = this.history.sort((a, b) => {
          if (new Date(a.createdAt).getTime() > new Date(b.createdAt).getTime())
            return 1;
          else return -1;
        })
        if(this.drpdwnParam === 'PM2.5'){
          this.setChartData('PM25');
        }
        else {
          this.setChartData(this.drpdwnParam);
        }
        this.loading = 0;
      });
    },
    maximize(pol) {
      this.expandPol = pol;
    },
    getDeviceData(id) {
      let deviceId = this.$route.params.deviceId;
      this.devId = deviceId;
      this.graphDevId = deviceId;
      const url = `device/by-devid/${deviceId}`;
      apiCall({ url, method: "get" }).then((result) => {
        this.devData = result.data;
        this.setDrpDownPrms(result.data);
      });
    },
    setDrpDownPrms(device) {
      let allParams = [
        "TVOC",
        "HCHO",
        "PM1",
        "PM10",
        "PM25",
        "CO2",
        "CH20",
        "SO2",
        "NO2",
        "CO",
        "O3",
        "Temperature",
        "Pressure",
        "Humidity",
      ];
      let a = Object.keys(device);
      if (device) this.paramArray = allParams.filter((elm) => a.includes(elm) || a.includes(elm.toLowerCase()));
    },
    getPM25Range(num, type) {
      // this.PM25barwidth=`${num}%`;
      if (isNaN(num)) {
        return type === "color" ? "text-info" : "NA";
      } else if (num >= 0 && num <= 30) {
        if (num === 0) {
          this.PM25barwidth = "0%";
        } else {
          this.PM25barwidth = "30%";
        }
        return type === "color" ? "progress-bar bg-success" : "Good";
      } else if (num > 30 && num <= 60) {
        this.PM25barwidth = "60%";
        return type === "color" ? "progress-bar bg-warning" : "Moderate";
      } else {
        this.PM25barwidth = "90%";
        return type === "color" ? "progress-bar bg-danger" : "Unhealthy";
      }
    },
    getPM10Range(num, type) {
      if (isNaN(num)) {
        return type === "color" ? "text-info" : "NA";
      } else if (num >= 0 && num <= 50) {
        if (num === 0) {
          this.PM10barwidth = "0%";
        } else {
          this.PM10barwidth = "30%";
        }
        return type === "color" ? "progress-bar bg-success" : "Good";
      } else if (num > 50 && num <= 100) {
        this.PM10barwidth = "60%";
        return type === "color" ? "progress-bar bg-warning" : "Moderate";
      } else {
        this.PM10barwidth = "90%";
        return type === "color" ? "progress-bar bg-danger" : "Unhealthy";
      }
    },
    getCO2Range(num, type) {
      if (isNaN(num)) {
        return type === "color" ? "text-info" : "NA";
      } else if (num >= 0 && num <= 1080) {
        if (num === 0) {
          this.CO2barwidth = "0%";
        } else {
          this.CO2barwidth = "30%";
        }
        return type === "color" ? "progress-bar bg-success" : "Good";
      } else if (num > 1080 && num <= 1800) {
        this.CO2barwidth = "60%";
        return type === "color" ? "progress-bar bg-warning" : "Moderate";
      } else {
        this.CO2barwidth = "90%";
        return type === "color" ? "progress-bar bg-danger" : "Unhealthy";
      }
    },
    getPM1Range(num, type) {
      if (isNaN(num)) {
        return type === "color" ? "text-info" : "NA";
      } else if (num >= 0 && num <= 40) {
        if (num === 0) {
          this.PM1barwidth = "0%";
        } else {
          this.PM1barwidth = "30%";
        }
        return type === "color" ? "progress-bar bg-success" : "Good";
      } else if (num > 40 && num <= 60) {
        this.PM1barwidth = "60%";
        return type === "color" ? "progress-bar bg-warning" : "Moderate";
      } else {
        this.PM1barwidth = "90%";
        return type === "color" ? "progress-bar bg-danger" : "Unhealthy";
      }
    },
    getTVOCRange(num, type) {
      if (isNaN(num)) {
        return type === "color" ? "text-info" : "NA";
      } else if (num >= 0 && num <= 0.21) {
        if (num === 0) {
          this.TVOCbarwidth = "0%";
        } else {
          this.TVOCbarwidth = "30%";
        }
        return type === "color" ? "progress-bar bg-success" : "Good";
      } else if (num > 0.21 && num <= 0.56) {
        this.TVOCbarwidth = "50%";
        return type === "color" ? "progress-bar bg-warning" : "Moderate";
      } else {
        this.TVOCbarwidth = "90%";
        return type === "color" ? "progress-bar bg-danger" : "Unhealthy";
      }
    },
    getHCHORange(num, type) {
      if (isNaN(num)) {
        return type === "color" ? "text-info" : "NA";
      } else if (num >= 0 && num <= 0.03) {
        if (num === 0) {
          this.HCHObarwidth = "0%";
        } else {
          this.HCHObarwidth = "30%";
        }
        return type === "color" ? "progress-bar bg-success" : "Good";
      } else if (num > 0.03 && num <= 0.08) {
        this.HCHObarwidth = "50%";
        return type === "color" ? "progress-bar bg-warning" : "Moderate";
      } else {
        this.HCHObarwidth = "90%";
        return type === "color" ? "progress-bar bg-danger" : "Unhealthy";
      }
    },
    // goBack() {
    //   this.$routers.go(-1)
    // },
  },
  watch: {
    lastNReadings(val) {
      this.getDeviceReading();
    },
  },
};
</script>
<style>
.container {
  margin-left: 0rem;
  margin-right: 0rem;
}
.summary {
  font-family: Ubuntu;
  color: rgba(59, 59, 59, 0.8);
  height: 90vh;
}
.chart {
  background: #fff;
  /* box-shadow: 0 0 0.62rem 0 rgba(0, 0, 0, 0.2); */
  /* border-radius: 0.5rem; */
  height: 15.3 rem;
  font-family: Ubuntu;
  font-size: 10px;
  color: rgba(59, 59, 59, 0.8);
}
.graph {
  padding: 1rem;
}
.curr-pol {
  height: 10rem;
  color: rgba(59, 59, 59, 0.8);
}
small {
  color: rgb(133, 91, 66);
}
.ubuntu-small {
  font-family: Ubuntu;
  font-weight: 200;
  font-size: 10px;
  color: rgba(59, 59, 59, 0.8);
}
.ubuntu-medium {
  font-family: Ubuntu;
  font-weight: 500;
  font-size: 14px;
  color: rgba(59, 59, 59, 0.8);
}
.devName {
  font-family: Ubuntu;
  font-weight: 500;
  font-size: 15px;
  color: rgba(59, 59, 59, 0.8);
}
.curr-data {
  box-shadow: 0 0 0.62rem 0 rgba(0, 0, 0, 0.2);
  height: 100vh;
}

.filter-div {
  text-align: right;
}
.btn-sm:hover {
  color: #3498db;
}
.btn-sm {
  background-color: transparent;
  font-family: Ubuntu;
  font-weight: 500;
  font-size: 14px;
  color: rgba(59, 59, 59, 0.8);
}
.btn-sm.active {
  color: #3498db;
}
.btn-sm:focus {
  box-shadow: none;
}
.fa-expand:hover {
  transition: width 2s linear 1s;
}

#loader {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  width: 150px;
  height: 150px;
  margin: -75px 0 0 -75px;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

.spinner-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.6;
  z-index: 1;
  margin: -15px;
}
.rdngs {
  color : #f7b500;
  font-weight: 500;
}
.hdrs{
  font-size: 0.9rem;
}
.chartCont{
  border-radius: 5px;
  box-shadow: 0 0 0.62rem 0 rgba(0, 0, 0, 0.2);
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Add animation to "page content" */
.animate-bottom {
  position: relative;
  -webkit-animation-name: animatebottom;
  -webkit-animation-duration: 1s;
  animation-name: animatebottom;
  animation-duration: 1s;
}

@-webkit-keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0;
  }
  to {
    bottom: 0px;
    opacity: 1;
  }
}

@keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0;
  }
  to {
    bottom: 0;
    opacity: 1;
  }
}
</style>
